import { getCfg } from "../../utils/getCfg.js";
import { getCookie, setCookie } from "../../utils/cookie.js";

export class DisclaimerCookie {
    selectors = {
        instance: "[data-js-disclaimer]",
        acceptBtn: "[data-js-disclaimer-accept]",
    }

    stateClasses = {
        isShow: "isShow",
    }

    states = {
        isOpen: true,
    };

    defaultCfg = {}

    constructor() {
        this.instance = document.querySelector(this.selectors.instance)
        console.debug(this.instance)
        if(!this.instance) {
            return;
        }

        this.cfg = getCfg(this.instance, this.selectors.instance, this.defaultCfg)

        this.acceptBtn = null;

        this.init();
    }

    /**
     *Метод инициализирует выполнение методов, необходимых для начала работы дисклеймера
     */
    init() {
        this.acceptBtn = this.instance.querySelector(this.selectors.acceptBtn);
        console.debug(this.acceptBtn)
        this.manageCookieVisibility();
        this.bindEvents();
    }


    /**
     * Метод закрывает дисклеймер
     */
    close() {
        if (!this.states.isOpen) {
            return;
        }
        console.debug("close")
        this.instance.classList.remove(this.stateClasses.isShow);
        this.states.isOpen = false;
    }

    /**
     * Метод показывает дисклеймер
     */
    show() {
        this.instance.classList.add(this.stateClasses.isShow);
        this.states.isOpen = true;
    }

    /**
     * Метод управляет показом дисклеймера
     */
    manageCookieVisibility() {
        if (!getCookie(this.cfg?.cookieName)) {
            console.debug("show")
            this.show();
        }
    }

    /**
     * Метод записывает значение куки
     * @param cookieName{String} - имя куки
     * @param cookieValue{String} - значение куки
     * @param cookieMaxAge{Number} - время жизни куки
     */
    #setCookie(cookieName, cookieValue, cookieMaxAge) {
        console.debug("setCoockie")
        setCookie(cookieName, cookieValue, { "max-age": cookieMaxAge, path: "/" });
    }

    /**
     * Метод обработки клика по кнопке принятия кук
     */
    #handleClick() {
        this.close();
        const { cookieName, cookieAcceptValue, cookieMaxAge } = this.cfg;
        if (!!cookieName && !!cookieAcceptValue && !!cookieMaxAge) {
            this.#setCookie(cookieName, cookieAcceptValue, cookieMaxAge);
        }
    }

    /**
     * Метод привязывает события к DOM-элементам
     */
    bindEvents() {
        if (this.acceptBtn) {
            this.acceptBtn.addEventListener("click", () => this.#handleClick());
        }
    }
}
